import { Component, OnInit , OnDestroy} from '@angular/core';
import { EmitterService } from '../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
@Component({
  selector: 'app-custom-error-msg',
  templateUrl: './app-custom-error-msg.component.html',
  styleUrls: ['./app-custom-error-msg.component.scss']
})
export class AppCustomErrorMsgComponent implements OnInit, OnDestroy {

  serverErrorMsg: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private emitterService: EmitterService
  ) {
    this.emitterService.customServerError$.pipe(takeUntil(this.destroy$)).subscribe(status=>{
        if (status.length !== 0) {
          this.serverErrorMsg = status;
          // this.utility.openModal('servermsgmodal')
        }
      }
    );
  }

  ngOnInit() {
    this.emitterService.customServerError$.pipe(takeUntil(this.destroy$)).subscribe(status=>{
        if (status.length !== 0) {
          this.serverErrorMsg = status;
          // this.utility.openModal('servermsgmodal')
        }
      }
    );
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
